import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { bool } from 'prop-types';
import get from 'lodash/get';
import { detectSafari } from 'yoda-core-components/lib/helpers/Utils/Utils';
import Accordion from 'yoda-core-components/lib/components/Accordion/accordion';
import BVSummary from 'yoda-site-components/lib/components/BVSummary/BVSummary';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import {
    selectFeatureFlags,
    selectDeviceName,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import { selectProductDetailsBySource } from 'yoda-site-components/lib/selectors/PdpNameSpaceSelector';
import { selectProductReviewID } from 'yoda-site-components/lib/selectors/ProductDetailsSelector';
import BazaarVoice from './BazaarVoiceLazy';

export const CONSTANTS = {
    btnLabel: 'Show Reviews',
};

export const renderMobileAccordion = (
    featureFlags,
    productDetails,
    productReviewID,
    bvReviewRef
) => {
    const ArrayOfAccordionSection = [];
    if (get(featureFlags, 'bazaarVoice', true)) {
        const ReviewAccordionTitle = (
            <>
                <div
                    id="reviewSectionId"
                    className={dt(['inline-block', 'sm:!text-lg', 'sm:!leading-6', 'text-black'])}
                >
                    Reviews
                </div>

                <div className={dt(['inline-block', 'align-middle'])}>
                    <ErrorBoundary>
                        <BVSummary isAccordion="true" productDetails={productDetails} />
                    </ErrorBoundary>
                </div>
            </>
        );

        let content = (
            <ErrorBoundary>
                <BazaarVoice
                    containerId="BVReviewsContainer"
                    contentType="reviews"
                    submissionContainerId="BVSubmissionContainer"
                />
            </ErrorBoundary>
        );
        content = [
            <ErrorBoundary>
                <>
                    <>
                        <div
                            data-bv-show="review_highlights"
                            data-bv-product-id={productReviewID}
                            id="reviewSectionId"
                        />
                        <div
                            data-bv-show="reviews"
                            data-bv-product-id={productReviewID}
                            id="reviewSectionId"
                            ref={bvReviewRef}
                        />{' '}
                    </>

                    <BazaarVoice
                        containerId="BVReviewsContainer"
                        submissionContainerId="BVReviewsContainer"
                        contentType="reviews"
                        // showLoader={false}
                    />
                </>
            </ErrorBoundary>,
            get(featureFlags, 'customerPhotos', true) && (
                <ErrorBoundary>
                    <BazaarVoice containerId="bv-gallery" showLoader={false} />
                </ErrorBoundary>
            ),
        ];

        ArrayOfAccordionSection.push({
            header: ReviewAccordionTitle,
            panel: content,
            key: 'reviewSectionId',
        });
    }

    if (get(featureFlags, 'bazaarVoice', true)) {
        ArrayOfAccordionSection.push({
            header: (
                <span
                    id="QASectionId"
                    className={dt(['inline-block', 'sm:!text-lg', 'sm:!leading-6', 'text-black'])}
                >
                    Questions & Answers
                </span>
            ),
            panel: (
                <ErrorBoundary>
                    <div data-bv-show="questions" data-bv-product-id={productReviewID} />

                    <BazaarVoice
                        containerId="BVQuestionsContainer"
                        contentType="qa"
                        submissionContainerId="BVQASubmissionContainer"
                    />
                </ErrorBoundary>
            ),
            key: 'QASectionId',
        });
    }
    return ArrayOfAccordionSection;
};

const RenderBazaarVoice = (props) => {
    const featureFlags = useSelector((state) => selectFeatureFlags(state));
    const deviceName = useSelector((state) => selectDeviceName(state));
    const productDetails = useSelector((state) => selectProductDetailsBySource(false)(state));
    const productReviewID = useSelector((state) => selectProductReviewID(state));
    const isLoaded = useSelector((state) => state.BVReviews.isLoaded);
    const [showReviews, setShowReviews] = useState(false);
    const bvReviewRef = useRef(null);
    const isReviewAvailable =
        productDetails &&
        productDetails.valuation &&
        productDetails.valuation.reviews &&
        productDetails.valuation.reviews.count > 0;
    let buttonRendered = false;
    let pageLoadStatus = '';

    /* istanbul ignore next */
    const callBackForObserver = () => {
        if (bvReviewRef.current.shadowRoot) {
            const bvReviewMainContainer = bvReviewRef.current.shadowRoot.querySelector(
                '#bv_review_maincontainer'
            );
            const divsUnderReviewMainContainer =
                bvReviewMainContainer && bvReviewMainContainer.children;
            const showReviewsButtonContainer = document.querySelector('#BVReviewsContainer');

            if (!buttonRendered) {
                const buttonClasses = dt([
                    'my-8',
                    'mx-auto',
                    'w-auto',
                    'p-2',
                    'border-solid',
                    'border',
                    'border-gray-40',
                    'rounded-lg',
                    'flex',
                    'text-base',
                    'font-semibold',
                    'hover:bg-light-white',
                ]);
                const showReviewsButton = `<button id=\"showReviews\" class=\"${buttonClasses}\">${CONSTANTS.btnLabel}</button>`;
                showReviewsButtonContainer.insertAdjacentHTML('beforeend', showReviewsButton);
                showReviewsButtonContainer
                    .querySelector('button')
                    .addEventListener('click', onShowReviewsClick);
                buttonRendered = true;
            }

            if (divsUnderReviewMainContainer && divsUnderReviewMainContainer.length > 0) {
                for (let i = 0; i < divsUnderReviewMainContainer.length; i++) {
                    const divToHide = divsUnderReviewMainContainer[i];
                    if (i === 0) continue;
                    if (i === 1) {
                        const reviewSummaryDivs = divToHide.children || [];
                        if (reviewSummaryDivs[0])
                            reviewSummaryDivs[0].style.borderBottom = '1px solid #eaeaea';
                        if (reviewSummaryDivs[2]) reviewSummaryDivs[2].style.display = 'none';
                        continue;
                    }
                    divToHide.style.display = 'none';
                }
            }
            pageLoadStatus = document.readyState;
        }
    };

    /* istanbul ignore next */
    useEffect(() => {
        const { enableShowReviewsButtonOnReviewSection = false } = featureFlags;
        if (
            enableShowReviewsButtonOnReviewSection &&
            pageLoadStatus !== 'complete' &&
            isReviewAvailable
        ) {
            const mutationObserver = new MutationObserver(callBackForObserver);
            if (!showReviews) {
                const options = {
                    characterData: true,
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeOldValue: true,
                    characterDataOldValue: true,
                };
                bvReviewRef.current &&
                    bvReviewRef.current.shadowRoot &&
                    mutationObserver.observe(bvReviewRef.current.shadowRoot, options);
                return () => {
                    mutationObserver.disconnect();
                };
            }
            mutationObserver.disconnect();
        }
    }, [bvReviewRef, isLoaded, showReviews]);

    /* istanbul ignore next */
    const onAccordionClick = (e) => {
        const { enableShowReviewsButtonOnReviewSection = false } = featureFlags;
        enableShowReviewsButtonOnReviewSection &&
            (pageLoadStatus === 'complete' || pageLoadStatus === 'interactive') &&
            setShowReviews(true);
    };

    /* istanbul ignore next */
    const displayAllReviews = (divsUnderReviewMainContainer) => {
        for (let i = 0; i < divsUnderReviewMainContainer.length; i++) {
            const divToShow = divsUnderReviewMainContainer[i];
            if (i === 0) continue;
            if (i === 1) {
                const reviewSummaryDivs = divsUnderReviewMainContainer[1].children || [];
                if (reviewSummaryDivs[2]) reviewSummaryDivs[2].style.display = 'block';
                continue;
            }
            if (
                i === divsUnderReviewMainContainer.length - 1 &&
                divToShow.childNodes[0]?.textContent === 'Load More'
            ) {
                divToShow.style.display = 'flex';
                continue;
            }
            divToShow.style.display = 'block';
        }
    };

    /* istanbul ignore next */
    const onShowReviewsClick = () => {
        setShowReviews(true);

        if (bvReviewRef.current.shadowRoot) {
            const bvReviewMainContainer = bvReviewRef.current.shadowRoot.querySelector(
                '#bv_review_maincontainer'
            );
            const divsUnderReviewMainContainer =
                bvReviewMainContainer && bvReviewMainContainer.children;
            const showReviewsButtonContainer = document.querySelector('#BVReviewsContainer');
            const showReviewsutton = showReviewsButtonContainer.querySelector('button');

            showReviewsutton.removeEventListener('click', onShowReviewsClick);
            showReviewsutton.remove();

            if (divsUnderReviewMainContainer && divsUnderReviewMainContainer.length > 0) {
                detectSafari() && deviceName === 'desktop'
                    ? setTimeout(() => {
                          displayAllReviews(divsUnderReviewMainContainer);
                      }, 100)
                    : displayAllReviews(divsUnderReviewMainContainer);
            }
        }
    };
    if (props.mobileTabletLogic) {
        return renderMobileAccordion(featureFlags, productDetails, productReviewID, bvReviewRef);
    }
    if (get(featureFlags, 'enableDesktopAccordionBV', true)) {
        return (
            <ErrorBoundary>
                <Accordion
                    automationId="product-info-accordion"
                    className={dt(['lg:mb-10'])}
                    onClick={onAccordionClick}
                >
                    {renderMobileAccordion(
                        featureFlags,
                        productDetails,
                        productReviewID,
                        bvReviewRef
                    )}
                </Accordion>
            </ErrorBoundary>
        );
    }
    return null;
};

RenderBazaarVoice.defaultProps = {
    mobileTabletLogic: false,
};

RenderBazaarVoice.propTypes = {
    mobileTabletLogic: bool,
};

export default RenderBazaarVoice;
